module.exports = __webpack_public_path__ + "static/media/designPatent_30-1064854.4a238f24.png";